import React, { PureComponent } from 'react';
import cx from 'classnames';
import KlickLogo from '../../common/KlickLogo';
import {
  disableScroll,
  enableScroll,
  fireGATrackingEvent,
} from '../../common/utils';

import s from './styles/Header.module.scss';

class Header extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isMobileNavOpen: false,
    };
  }

  openMobileNav = () => {
    this.setState({
      isMobileNavOpen: true,
    });
    disableScroll();
  };

  closeMobileNav = () => {
    if (!this.state.isMobileNavOpen) {
      return;
    }

    this.setState({
      isMobileNavOpen: false,
    });
    enableScroll();
  };

  render = () => {
    const { isMobileNavOpen } = this.state;

    return (
      <div className={s.Header}>
        <div className={s.wrapper}>
          <div className={s.logo}>
            <a
              href="https://www.klick.com"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                fireGATrackingEvent(
                  'Outbound Links',
                  'Click',
                  'https://www.klick.com'
                );
              }}
            >
              <KlickLogo className={s.logoImage} />
            </a>
          </div>
          <div className={s.menu}>
            <div
              className={cx(s.menuButton, { [s.alt]: isMobileNavOpen })}
              onClick={
                this.state.isMobileNavOpen
                  ? this.closeMobileNav
                  : this.openMobileNav
              }
            >
              <div />
              <div />
              <div />
            </div>
            <ul className={cx(s.links, { [s.slideIn]: isMobileNavOpen })}>
              <li className={s.klickhealthlink}>
                <a
                  href="https://www.klick.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    this.closeMobileNav();
                    fireGATrackingEvent(
                      'Outbound Links',
                      'Click',
                      'https://www.klick.com'
                    );
                  }}
                >
                  Klick Health
                </a>
              </li>
              <li>
                <a
                  href="https://www.klick.com/brands#klick-labs"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    this.closeMobileNav();
                    fireGATrackingEvent(
                      'Outbound Links',
                      'Click',
                      'https://www.klick.com/brands#klick-labs'
                    );
                  }}
                >
                  Klick Labs
                </a>
              </li>
              <li>
                <a
                  href="https://www.senseilabs.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    this.closeMobileNav();
                    fireGATrackingEvent(
                      'Outbound Links',
                      'Click',
                      'https://www.senseilabs.com'
                    );
                  }}
                >
                  Sensei Labs
                </a>
              </li>
              <li>
                <a
                  href="https://careers.klick.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    this.closeMobileNav();
                    fireGATrackingEvent(
                      'Outbound Links',
                      'Click',
                      'https://careers.klick.com'
                    );
                  }}
                >
                  Careers @ Klick
                </a>
              </li>
              <li>
                <a
                  href="https://www.klick.com/health/blog"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    this.closeMobileNav();
                    fireGATrackingEvent(
                      'Outbound Links',
                      'Click',
                      'https://www.klick.com/health/blog'
                    );
                  }}
                >
                  Digital RX Blog
                </a>
              </li>
              <li>
                <a
                  href="https://www.klick.com/health/announcements"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    this.closeMobileNav();
                    fireGATrackingEvent(
                      'Outbound Links',
                      'Click',
                      'https://www.klick.com/health/announcements'
                    );
                  }}
                >
                  Media
                </a>
              </li>
              <li>
                <a
                  href="https://www.klick.com/contact"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    this.closeMobileNav();
                    fireGATrackingEvent(
                      'Outbound Links',
                      'Click',
                      'https://www.klick.com/contact'
                    );
                  }}
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  };
}

export default Header;
